// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Condition view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...ConditionRender }`, [ConditionRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const ConditionRenderFragment = graphql(`
  fragment ConditionRender on Condition @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    clinicalStatus {
      text
      coding {
        system
        code
        display
      }
    }
    verificationStatus {
      text
      coding {
        system
        code
        display
      }
    }
    category {
      text
      coding {
        system
        code
        display
      }
    }
    severity {
      text
      coding {
        system
        code
        display
      }
    }
    code {
      text
      coding {
        system
        code
        display
      }
    }
    bodySite {
      text
      coding {
        system
        code
        display
      }
    }
    subject {
      reference
      type
      display
    }
    encounter {
      reference
      type
      display
    }
    onsetDateTime
    onsetAge {
      value
      comparator
      unit
      system
      code
    }
    onsetPeriod {
      start
      end
    }
    onsetRange {
      low {
        value
        comparator
        unit
        system
        code
      }
      high {
        value
        comparator
        unit
        system
        code
      }
    }
    onsetString
    abatementDateTime
    abatementAge {
      value
      comparator
      unit
      system
      code
    }
    abatementPeriod {
      start
      end
    }
    abatementRange {
      low {
        value
        comparator
        unit
        system
        code
      }
      high {
        value
        comparator
        unit
        system
        code
      }
    }
    abatementString
    recordedDate
    recorder {
      reference
      type
      display
    }
    asserter {
      reference
      type
      display
    }
    stage {
      summary {
        text
        coding {
          system
          code
          display
        }
      }
      assessment {
        reference
        type
        display
      }
      type {
        text
        coding {
          system
          code
          display
        }
      }
    }
    evidence {
      code {
        text
        coding {
          system
          code
          display
        }
      }
      detail {
        reference
        type
        display
      }
    }
    note {
      authorReference {
        reference
        type
        display
      }
      authorString
      time
      text
    }
  }
`);
